export default "__VITE_ASSET__DxjXGWRA__"